export default __webpack_public_path__ + "static/yoga-12-a8f50aae302cf268153642fc2a4203b3.png";